import React from "react";
import styled from "styled-components";

import { App } from '../../app';
import { ResourceStrings } from "../../ResourceStrings";
import * as urls from "../../constants/urls";

export interface PrivacyDisclosureProps {
    disclosure: string;
    disclosureLink: string;
    includesNativeAttachments: boolean;
}

export default function PrivacyDisclosure(props: PrivacyDisclosureProps): JSX.Element {
    const privacyLink = `<a href=${urls.getPrivacyStatementUrl()} target="_blank" rel="noopener noreferrer">${ResourceStrings.msftPrivacyStatement()}</a>`;
    const dataWeCollectLink = `<a href=${urls.dataWeCollect} target="_blank" rel="noopener noreferrer">${ResourceStrings.dataWeCollect()}</a>`;
    const msftSupportLink = `<a href=${urls.msftSupport} target="_blank" rel="noopener noreferrer">${ResourceStrings.msftSupportStatement()}</a>`;

    const clickPrivacy = (): boolean => {
        App.telemetry.postBusinessEvent("privacylink-clicked");
        return true; // process click further
    }

    const clickDevCom = (): boolean => {
        App.telemetry.postBusinessEvent("devcomlink-clicked");
        return true; // process click further
    }

    const clickMsftSupport = (): boolean => {
        App.telemetry.postBusinessEvent("msftSupportLink-clicked");
        return true; // process click further
    }

    const clickDataWeCollect = (): boolean => {
        App.telemetry.postBusinessEvent("datawecollect-clicked");
        return true; // process click further
    }

    return <Container>
        <span className="text-left">
            <span
                className="text"
                onClick={(evt) => clickDataWeCollect()}
                aria-label={ResourceStrings.dataWeCollect()}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: dataWeCollectLink }} />.&nbsp;

                {props.includesNativeAttachments && <span aria-label={ResourceStrings.privateDisclosureAttachments()}>{ResourceStrings.privateDisclosureAttachments() + ' '}</span>}
            <span
                className="text"
                onClick={(evt) => clickDevCom()}
                aria-label={props.disclosure}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: props.disclosureLink }} />&nbsp;
            <span
                className="text"
                onClick={(evt) => clickMsftSupport()}
                aria-label={ResourceStrings.msftSupportDisclosure(ResourceStrings.msftSupportStatement())}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: ResourceStrings.msftSupportDisclosure(msftSupportLink) }} />
        </span>

        <span className="text-left">
            <span
                className="text"
                onClick={(evt) => clickPrivacy()}
                aria-label={ResourceStrings.privacyDisclosure(ResourceStrings.msftPrivacyStatement())}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: ResourceStrings.privacyDisclosure(privacyLink) }} />
        </span>
    </Container>
}

const Container = styled.div`
    font-size: 1.4rem;
`;
